import { toast } from "../../utils/toast";
import Smiley from "../../assets/icons/smiley.svg";
import SendButton from "../../assets/icons/send_btn.svg";
import ChatIcon from "../../assets/icons/chat_icon.svg";
import Verified from "../../assets/icons/verified.svg";
import ChatIcon2 from "../../assets/icons/chat_icon2.svg";
import AddButton from "../../assets/icons/add_btn.svg";
import AddButtonLight from "../../assets/lightIcons/chat_light.svg";
import StorageManager from "../EmbedChannels/utility/storage_manager";
import Menu from "../../assets/icons/menu.svg";
import Media from "../../assets/icons/media.svg";
import Document from "../../assets/icons/document.svg";
import Poll from "../../assets/icons/graph.svg";
import Event from "../../assets/icons/calendar.svg";
import EventLight from "../../assets/lightIcons/calendar_light.svg";
import EmojiPicker, { EmojiStyle } from "emoji-picker-react";
import PageChatData from "./PageChatData";
import { v4 as uuidv4 } from "uuid";
import PdfImage from "../../assets/images/pdf_img.svg";
import Delete from "../../assets/icons/Delete.svg";
import Close from "../../assets/icons/Close.svg";
import socket from "../../utils/socket";
import Compressor from "compressorjs";

import {
  setChatField,
  addMediaItem,
  removeMediaItem,
  clearChat,
  createTopicChat,
  createBrandChat,
  clearMedia,
  markAsRead,
} from "../../redux/slices/chatSlice";
import { setEventField, clearEvent } from "../../redux/slices/eventSlice";
import { fetchMembers } from "../../redux/slices/reorderTopicSlice";
import { setEmbedItem } from "../EmbedChannels/embedSlices/embedHomeSlice";
import { FiCpu, FiMessageCircle } from "react-icons/fi";
import { setPollField, clearChatPoll } from "../../redux/slices/pollSlice";
import {
  updateWhatsAppNumber,
  saveWhatsAppNumber,
} from "../../redux/slices/myDataSlice";
import OtpInput from "react-otp-input";
import PhoneInput from "react-phone-input-2";
import PageHeader from "./PageHeader";
import PageChatData2 from "./PageChatData2";
import {
  React,
  useState,
  useEffect,
  useRef,
  useDispatch,
  useSelector,
  useModal,
  isEmbeddedOrExternal,
  postRequestAuthenticated,
} from "../../globals/imports";

const PageChat = ({
  topicId,
  topic,
  channelId,
  isLoggedIn,
  myData,
  channel,
  channelName,
  toggleBottomSheet,
  isOpen,
  username,
}) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const isDark = document.documentElement.classList.contains("dark");
  const [showAddMenu, setShowAddMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [notificationDropdown, setNotificationDropdown] = useState(false);
  const [successPage, setSuccessPage] = useState(false);
  const [otpPage, setOtpPage] = useState(false);
  const [otpBackend, setOtpBackend] = useState("");
  const [otp, setOtp] = useState("");
  const [isBrandTalk, setIsBrandTalk] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  const [error, setError] = useState("");
  const [fileObjects, setFileObjects] = useState([]);
  const inputRef = useRef(null);
  const addMenuRef = useRef(null);
  const addMenuButtonRef = useRef(null);
  const recognitionRef = useRef(null);
  const [isListening, setIsListening] = useState(false);
  const dispatch = useDispatch();
  // Embed feature toggles (undefined outside the embed -> everything shows).
  const features = useSelector((state) => state.embedHome?.features) || {};
  const fileInputRef = useRef(null);
  const emojiButtonRef = useRef(null);

  const emojiRef = useRef(null);
  const channelChat = useSelector((state) => state.chat);
  const chatStatus = useSelector((state) => state.chat.chatStatus);
  const newMessageScrollRef = useRef(null);
  const scrollToChatRef = useRef(null);
  const Chats = useSelector((state) => state.chat.chats);
  // Pinned messages currently loaded in this topic (Chats is oldest-first, so
  // the newest pinned message is last). Rendered in a slim bar above the list.
  const pinnedChats = Chats.filter((c) => c.pinned);
  const latestPinned = pinnedChats[pinnedChats.length - 1];
  const { handleOpenModal } = useModal();

  // --- @mention: WhatsApp-style member tagging -------------------------------
  const members = useSelector((state) => state.reorderTopic.members) || [];
  // Bot Studio bot (embed only) — surfaced as a special @mention entry.
  const bot = useSelector((state) => state.embedHome?.bot) || {};
  // Bumped (timestamp) by the bot's take_to_support action to open Talk-to-us.
  const openTalkToUsSignal = useSelector((state) => state.embedHome?.openTalkToUs);
  const [mentionQuery, setMentionQuery] = useState(null); // null = picker closed
  const [mentionIndex, setMentionIndex] = useState(0);

  useEffect(() => {
    if (channelId) dispatch(fetchMembers(channelId));
  }, [channelId, dispatch]);

  // Bot's "take_to_support" action -> switch this composer to the Talk-to-us
  // (brand) chat, if that feature is on and this isn't the owner's own topic.
  useEffect(() => {
    if (
      openTalkToUsSignal &&
      features.talkToBrand !== false &&
      topic?.user !== myData?._id
    ) {
      setIsBrandTalk(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openTalkToUsSignal]);

  // The active "@token" = the run after the last "@" that sits at a word
  // boundary (start/whitespace) with no whitespace between it and the caret.
  const getMentionContext = (text, caret) => {
    const upto = text.slice(0, caret);
    const at = upto.lastIndexOf("@");
    if (at === -1) return null;
    const before = at === 0 ? " " : upto[at - 1];
    if (!/\s/.test(before)) return null; // e.g. don't trigger on an email
    const query = upto.slice(at + 1);
    if (/\s/.test(query)) return null;
    return { at, query };
  };

  const mentionMatches =
    mentionQuery === null
      ? []
      : members
          .filter((m) => {
            const u = m.user || m;
            const q = mentionQuery.toLowerCase();
            return (
              (u.username || "").toLowerCase().includes(q) ||
              (u.name || "").toLowerCase().includes(q)
            );
          })
          .slice(0, 6);

  // Replace the "@query" the user is typing with "@username " and record the
  // member's id in the mentions array (deduped).
  const insertMention = (member) => {
    const u = member.user || member;
    const el = inputRef.current;
    const text = channelChat.content || "";
    const caret = el ? el.selectionStart : text.length;
    const ctx = getMentionContext(text, caret);
    if (!ctx) return;
    const insert = `@${u.username} `;
    const newText = text.slice(0, ctx.at) + insert + text.slice(caret);
    dispatch(setChatField({ field: "content", value: newText }));
    setData(newText);
    dispatch(
      setChatField({
        field: "mentions",
        value: Array.from(new Set([...(channelChat.mentions || []), u._id])),
      })
    );
    setMentionQuery(null);
    const pos = ctx.at + insert.length;
    requestAnimationFrame(() => {
      if (el) {
        el.focus();
        el.setSelectionRange(pos, pos);
        autoExpand(el);
      }
    });
  };

  // A native <textarea> can't color a substring, so to show a mention in light
  // blue inside the input we paint a mirror <div> behind a transparent-text
  // textarea (shares its exact box model). This renders that mirror content.
  const memberUsernames = new Set(
    members.map((m) => (m.user || m).username?.toLowerCase()).filter(Boolean)
  );
  const renderComposerHighlight = (text) =>
    (text || "").split(/(@[a-zA-Z0-9_.]+)/g).map((part, i) => {
      const uname = part[0] === "@" ? part.slice(1).toLowerCase() : null;
      return uname && memberUsernames.has(uname) ? (
        <span key={i} className="text-sky-400">
          {part}
        </span>
      ) : (
        <span key={i}>{part}</span>
      );
    });

  // The Bot Studio bot shows at the top of the @ list when enabled and the
  // typed query matches its handle. Picking it opens the bot chat panel rather
  // than inserting a text mention.
  const showBotEntry =
    mentionQuery !== null &&
    !!bot.enabled &&
    !!bot.chatMention && // Growth-only "summon in chat" flag
    !!bot.name &&
    (mentionQuery === "" ||
      bot.name.toLowerCase().includes(mentionQuery.toLowerCase()));

  const openBot = () => {
    const el = inputRef.current;
    const text = channelChat.content || "";
    const caret = el ? el.selectionStart : text.length;
    const ctx = getMentionContext(text, caret);
    if (ctx) {
      const newText = text.slice(0, ctx.at) + text.slice(caret);
      dispatch(setChatField({ field: "content", value: newText }));
      setData(newText);
    }
    setMentionQuery(null);
    dispatch(setEmbedItem({ field: "botTrigger", value: null })); // manual = plain greeting
    dispatch(setEmbedItem({ field: "botChatOpen", value: true }));
  };
  const previousChatLength = useRef(0);
  const [isChecked, setIsChecked] = useState(false);

  // Unread "Talk to us" (brand) reply -> dot on the Talk-to-us button.
  const [brandUnread, setBrandUnread] = useState(false);
  const isBrandTalkRef = useRef(isBrandTalk);
  useEffect(() => {
    isBrandTalkRef.current = isBrandTalk;
  }, [isBrandTalk]);

  // On load: does the member have an unread brand reply waiting?
  useEffect(() => {
    if (!isLoggedIn || !myData?._id || features.talkToBrand === false) return;
    postRequestAuthenticated("/fetch/brand/unread", {})
      .then((res) => {
        if (res?.success) setBrandUnread(!!res.hasUnread);
      })
      .catch(() => {});
  }, [isLoggedIn, myData?._id]);

  // Live: a brand reply arriving while the member isn't in the Talk-to-us view.
  useEffect(() => {
    const onBrandDM = (msg) => {
      if (msg?.chatType !== "brand") return;
      const senderId = String(msg?.sender?._id || msg?.sender || "");
      if (!senderId || senderId === String(myData?._id)) return; // own echo
      if (!isBrandTalkRef.current) setBrandUnread(true);
    };
    socket.on("dm_message", onBrandDM);
    return () => socket.off("dm_message", onBrandDM);
  }, [myData?._id]);


  useEffect(() => {
    if (myData.whatsapp_number === "") {
      setNotificationDropdown(true);
    }
  }, []);

  useEffect(() => {
    setFileObjects([]);
    handleReplyClear();
    dispatch(clearMedia());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topicId, dispatch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        addMenuRef.current &&
        !addMenuRef.current.contains(event.target) &&
        addMenuButtonRef.current &&
        !addMenuButtonRef.current.contains(event.target)
      ) {
        setShowAddMenu(false);
      }
      if (
        emojiRef.current &&
        !emojiRef.current.contains(event.target) &&
        emojiButtonRef.current &&
        !emojiButtonRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const onEmojiClick = (event, emojiObject) => {
    const emoji = event.emoji;
    dispatch(
      setChatField({ field: "content", value: channelChat.content + emoji })
    );
    inputRef.current.focus();
  };

  const previewConfig = {
    showPreview: false,
  };
  const handleRemoveMedia = (index, id) => {
    dispatch(removeMediaItem(index));
    setFileObjects(fileObjects.filter((_, i) => i !== index));
  };
  useEffect(() => {
    if (myData.whatsapp_number === "") {
      setNotificationDropdown(true);
    }
  }, []);

  const handleMediaChange = (event) => {
    const files = Array.from(event.target.files);
    const maxFileSize = 20 * 1024 * 1024;

    if (files.length <= 10) {
      const newFiles = []; // Array to hold files, including compressed images
      const promises = files.map((file) => {
        return new Promise((resolve, reject) => {
          if (file.size > maxFileSize) {
            toast(
              `The file "${file.name}" exceeds the 20 MB size limit and will not be uploaded.`
            );
            return resolve(null); // Skip the file
          }

          if (
            file.size >= 8 * 1024 * 1024 &&
            file.size <= maxFileSize &&
            file.type.startsWith("image")
          ) {
            // If the file is an image and larger than 8MB, compress it
            new Compressor(file, {
              quality: 0.5,
              maxWidth: 1920,
              maxHeight: 1080,
              success(result) {
                const newFile = {
                  id: uuidv4(),
                  url: URL.createObjectURL(result),
                  name: result.name,
                  type: result.type.startsWith("video") ? "video" : "image",
                  size: result.size,
                };
                dispatch(addMediaItem(newFile)); // Dispatch compressed image
                newFiles.push(result); // Add compressed image to newFiles
                resolve();
              },
              error(err) {
                toast("Image compression failed: " + err);
                reject(err);
              },
            });
          } else {
            const newFile = {
              id: uuidv4(),
              url: URL.createObjectURL(file),
              name: file.name,
              type: file.type.startsWith("video") ? "video" : "image",
              size: file.size,
            };
            dispatch(addMediaItem(newFile)); // Dispatch the original file
            newFiles.push(file); // Add original file to newFiles
            resolve();
          }
        });
      });

      Promise.all(promises)
        .then(() => {
          setFileObjects((prevFiles) => [...prevFiles, ...newFiles]);
          setShowAddMenu(false);
        })
        .catch((err) => {
          console.error("Error processing files:", err);
          setShowAddMenu(false);
        });
    } else {
      toast("You can upload up to 10 files only.");
      setShowAddMenu(false);
    }
  };

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    const maxFileSize = 16 * 1024 * 1024;

    const updatedFiles = [];

    const processFile = (file) => {
      return new Promise((resolve, reject) => {
        if (file.size > maxFileSize) {
          toast(`File "${file.name}" exceeds the 16 MB size limit.`);
          return resolve(null);
        }

        const objectUrl = URL.createObjectURL(file);
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (fileExtension === "pdf") {
          const reader = new FileReader();
          reader.onload = () => {
            const newFile = {
              id: uuidv4(),
              name: file.name,
              url: objectUrl,
              type: "document",
              size: file.size,
            };
            dispatch(addMediaItem(newFile));
            updatedFiles.push(file);
            resolve(file);
          };
          reader.onerror = () => {
            console.error(`Error reading PDF file "${file.name}".`);
            reject(file);
          };
          reader.readAsArrayBuffer(file);
        } else {
          const newFile = {
            id: uuidv4(),
            name: file.name,
            url: objectUrl,
            type: "document",
            size: file.size,
          };
          dispatch(addMediaItem(newFile));
          updatedFiles.push(file);
          resolve(file);
        }
      });
    };

    const filePromises = files.map((file) => processFile(file));
    await Promise.all(filePromises);

    setFileObjects((prevFiles) => [...prevFiles, ...updatedFiles]);
    setShowAddMenu(false);
  };

  // useEffect(() => {
  //   socket.on("connect", () => {
  //     if (myData._id) {
  //       socket.emit("identify_user", myData._id);
  //       dispatch(markAsRead(topicId));
  //     }
  //   });

  //   return () => {
  //     // socket.disconnect();
  //     socket.off("connect");
  //   };
  // }, [topicId]);

  useEffect(() => {
    if (myData._id && topicId) {
      dispatch(markAsRead(topicId));
    }
  }, [topicId, myData._id]);

  useEffect(() => {
    if (channelChat.media.length > 0 && inputRef.current) {
      inputRef.current.focus();
    }
  }, [channelChat.media]);

  const handleSendChat = () => {
    const extractLinks = (text) => {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.match(urlRegex) || [];
    };
    setLoading(true);

    const links = extractLinks(channelChat.content);
    // Reconcile mentions with the final text: keep only members whose
    // "@username" token still survives in the message (handles the user
    // deleting a tagged name after picking it).
    const usernameById = {};
    members.forEach((m) => {
      const u = m.user || m;
      if (u?._id) usernameById[u._id] = u.username;
    });
    const finalMentions = (channelChat.mentions || []).filter(
      (id) =>
        usernameById[id] && channelChat.content.includes("@" + usernameById[id])
    );
    const formDataToSend = new FormData();
    formDataToSend.append("content", channelChat.content);
    formDataToSend.append("media", JSON.stringify(channelChat.media));
    formDataToSend.append("mentions", JSON.stringify(finalMentions));
    formDataToSend.append("replyTo", channelChat.replyTo || null);
    formDataToSend.append("links", JSON.stringify(links));
    formDataToSend.append("channel", channelId);
    formDataToSend.append("topic", topicId);
    fileObjects.forEach((file) => {
      formDataToSend.append("files", file);
    });

    const messageData = {
      userId: myData._id,
      channel: channelId,
      topic: topicId,
      content: channelChat.content,
      media: channelChat.media,
      links: links,
      mentions: finalMentions,
      replyTo: channelChat.replyTo || null,
    };
    socket.emit("send_message", messageData);
    dispatch(createTopicChat(formDataToSend))
      .unwrap()
      .then((chat) => {
        dispatch(clearChat());
        setLoading(false);
        if (newMessageScrollRef.current) {
          newMessageScrollRef.current();
        }
        setFileObjects([]);
        if (inputRef.current) {
          inputRef.current.style.height = "inherit";
        }
        // Bot Studio "react to first post": server flags the member's first-ever
        // post -> pop the bot with a congrats. (Server already gated on
        // bot.enabled + the reactToFirstPost trigger.)
        if (chat?.botFirstPost) {
          dispatch(setEmbedItem({ field: "botTrigger", value: "firstpost" }));
          dispatch(setEmbedItem({ field: "botChatOpen", value: true }));
        }
      })
      .catch((error) => {
        setLoading(false);

        toast(error, "error");
        setFileObjects([]);
      });
  };
  const handleSendBrandChat = () => {
    if (!isBrandTalk) {
      return;
    }
    const storedEmbedData = StorageManager.getItem("embedData");
    const { domain } = JSON.parse(storedEmbedData);
    const extractLinks = (text) => {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.match(urlRegex) || [];
    };
    setLoading(true);

    const links = extractLinks(channelChat.content);
    const formDataToSend = new FormData();
    formDataToSend.append("content", channelChat.content);
    formDataToSend.append("media", JSON.stringify(channelChat.media));
    formDataToSend.append("replyTo", channelChat.replyTo || null);
    formDataToSend.append("links", JSON.stringify(links));
    formDataToSend.append("domain", domain);
    fileObjects.forEach((file) => {
      formDataToSend.append("files", file);
    });

    const messageData = {
      userId: myData._id,
      content: channelChat.content,
      media: channelChat.media,
      links: links,
      replyTo: channelChat.replyTo || null,
      domain: domain,
    };
    // socket.emit("send_message", messageData);
    dispatch(createBrandChat(formDataToSend))
      .unwrap()
      .then(() => {
        dispatch(clearChat());
        setLoading(false);
        setFileObjects([]);
        if (newMessageScrollRef.current) {
          newMessageScrollRef.current();
        }

        if (inputRef.current) {
          inputRef.current.style.height = "inherit";
        }
        if (inputRef.current) {
          inputRef.current.style.height = "inherit";
        }
      })
      .catch((error) => {
        setLoading(false);
        toast(error, "error");
        setFileObjects([]);
      });
  };

  useEffect(() => {
    if (myData?.username && topicId) {
      socket.emit("join_topic", { username: myData?.username, topicId });
      return () => {
        socket.emit("leave_topic", { username: myData?.username, topicId });
      };
    }
  }, [topicId, myData?.username]);

  const handleReplyClear = () => {
    dispatch(setChatField({ field: "replyTo", value: null }));
    dispatch(setChatField({ field: "replyUsername", value: "" }));
  };

  // Speech-to-text: dictate into the composer using the browser's Web Speech
  // API. Interim results stream in live; the final transcript is appended to
  // whatever was already typed.
  const toggleSpeechToText = () => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      toast("Voice typing isn't supported in this browser.");
      return;
    }
    if (isListening) {
      recognitionRef.current && recognitionRef.current.stop();
      return;
    }
    const rec = new SR();
    rec.lang = "en-US";
    rec.interimResults = true;
    rec.continuous = false;
    const base = (channelChat.content || "").trim();
    rec.onresult = (e) => {
      let transcript = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        transcript += e.results[i][0].transcript;
      }
      const next = (base ? base + " " : "") + transcript;
      dispatch(setChatField({ field: "content", value: next }));
      setData(next);
      if (inputRef.current) autoExpand(inputRef.current);
    };
    rec.onend = () => setIsListening(false);
    rec.onerror = () => setIsListening(false);
    recognitionRef.current = rec;
    setIsListening(true);
    rec.start();
  };

  const handleEventOpen = () => {
    dispatch(clearEvent());
    dispatch(setEventField({ field: "topic", value: topicId }));
    handleOpenModal("modalEventOpen");
  };

  const handlePollOpen = () => {
    dispatch(clearChatPoll());
    dispatch(setPollField({ field: "topic", value: topicId }));
    handleOpenModal("modalPollOpen");
  };

  const autoExpand = (field) => {
    field.style.height = "inherit";
    field.style.height = `${field.scrollHeight}px`;
  };

  const handlePhoneChange = (value, countryData) => {
    const countryCode = `+${countryData.dialCode}`;
    const phoneNumber = value.slice(countryData.dialCode.length);
    const formattedNumber = `${countryCode}${phoneNumber}`;
    setWhatsAppNumber(formattedNumber);
  };
  const handleCheckboxChange = () => {
    setIsChecked(true);
  };

  const handleSave = () => {
    if (whatsAppNumber.length < 12) {
      return;
    }
    dispatch(updateWhatsAppNumber(whatsAppNumber))
      .unwrap()
      .then((response) => {
        setOtpBackend(response.otp);
        setOtpPage(true);
        setError("");
      })
      .catch((error) => {
        setError(error);
        setOtpPage(false);
      });
  };

  const handleChangeOtp = async (value) => {
    setOtp(value);
    if (value.length === 6 && value.toString() === otpBackend) {
      dispatch(saveWhatsAppNumber(whatsAppNumber))
        .unwrap()
        .then(() => {
          setOtpPage(false);
          setSuccessPage(true);
          setWhatsAppNumber("");
          setError("");
        })
        .catch((error) => {
          setError(error);
        });
    } else if (value.length === 6) {
      setError("Enter Correct Otp");
    }
  };

  const handleCancel = () => {
    setOtpPage(false);
    setIsChecked(false);
    setWhatsAppNumber("");
    setOtp("");
    setOtpBackend("");
  };

  const handleCloseDropdown = () => {
    setOtpPage(false);
    setIsChecked(false);
    setNotificationDropdown(false);
    setWhatsAppNumber("");
    setOtp("");
    setOtpBackend("");
  };
  const handleChangeNumber = () => {
    setOtpPage(false);
    setOtp("");
    setOtpBackend("");
  };

  const handleBrandTalk = () => {
    // Opening the brand chat reads it -> clear the unread dot.
    if (!isBrandTalk) setBrandUnread(false);
    setIsBrandTalk(!isBrandTalk);
  };

  return (
    <div
      className={`w-full relative flex flex-col ${
        isEmbeddedOrExternal() ? "h-full" : "sm:h-full h-full-height-36"
      }`}
    >
      {!isBrandTalk && (
        <PageHeader
          channelName={channelName}
          topic={topic}
          topicId={topicId}
          // toggleSidebar={toggleSidebar}
          toggleBottomSheet={toggleBottomSheet}
          isOpen={isOpen}
          username={username}
          channelId={channelId}
          // isSidebarOpen={isSidebarOpen}
        />
      )}

      {isBrandTalk && (
        <div className="relative h-8 sm:h-10 bg-theme-secondaryBackground w-full shrink-0">
          <div
            className="absolute flex flex-row items-center space-x-1 top-2 sm:top-8 left-[40%] sm:left-[45%] border-theme-emptyEvent border rounded-full 
          bg-theme-tertiaryBackground z-20 text-theme-emptyEvent py-1 px-2 font-light text-xs sm:text-sm cursor-pointer"
            onClick={() => setIsBrandTalk(false)}
          >
            <img src={Close} alt="close" className="w-3 h-3" />
            <p> Close Chat</p>
          </div>
        </div>
      )}

      {/* {notificationDropdown && (
        <div
          className="z-40 w-full items-center bg-theme-chatDivider border-b
         border-theme-chatDivider px-3 py-2.5 flex flex-row justify-between"
        >
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              className="appearance-none w-5 h-5 border rounded  cursor-pointer
               checked:bg-transparent checked:border-white checked:before:content-['✓'] 
               checked:before:text-theme-secondaryText checked:before:text-sm checked:before:flex 
               checked:before:items-center checked:before:justify-center bg-theme-buttonEnable
               border-theme-primaryText"
              onChange={handleCheckboxChange}
              checked={isChecked}
            />
            <span className="xs:text-sm text-xs text-theme-description">
              Enable WhatsApp notifications for this conversation
            </span>
          </label>

          <img
            src={Close}
            alt="close"
            className="w-3.5 h-3.5 cursor-pointer"
            onClick={handleCloseDropdown}
          />
        </div>
      )} */}
      {/* {isChecked && (
        <div
          className="absolute z-[99] bottom-0 bg-theme-tertiaryBackground border-b w-full
         border-theme-chatDivider p-4 flex flex-col rounded-t-lg h-2/5"
        >
          {!successPage && (
            <p className="text-theme-secondaryText text-sm font-normal">
              {otpPage
                ? `Enter OTP sent on Whatsapp number ${whatsAppNumber}`
                : "Enter your WhastApp Number"}
            </p>
          )}

          {otpPage ? (
            <div className="flex flex-col mt-5">
              <OtpInput
                value={otp}
                onChange={handleChangeOtp}
                numInputs={6}
                renderSeparator={<span className="w-3"></span>}
                renderInput={(props) => (
                  <input
                    {...props}
                    style={{
                      width: "34px",
                      height: "40px",
                      border: "none",
                      borderBottom: isDark
                        ? "2px solid white"
                        : "2px solid #edecea", // bottom underline
                      backgroundColor: "transparent", // no box background
                      textAlign: "center",
                      color: isDark ? "white" : "#202020",
                      outline: "none", // removes blue highlight on focus
                      fontSize: "16px",
                    }}
                    inputMode="numeric"
                    pattern="[0-9]*"
                  />
                )}
              />

              <p className="text-theme-secondaryText text-xs font-light mt-8">
                Entered the wrong number?
                <span
                  className="ml-1 underline cursor-pointer"
                  onClick={handleChangeNumber}
                >
                  Update Number
                </span>
              </p>
            </div>
          ) : successPage ? (
            <div>
              <div className="text-theme-secondaryText text-sm font-normal flex flex-row space-x-2 items-center">
                <img src={Verified} alt="success" className="h-4 w-4" />
                <p>Success!</p>
              </div>

              <p className="text-theme-secondaryText text-sm font-normal mt-4">
                Whatsapp notifications have been turned on. You can change your
                preferences on the settings page later.
              </p>

              <button
                className={`w-full py-2.5 mt-5 rounded-lg 
               text-theme-secondaryText bg-theme-buttonEnable
             font-normal text-sm`}
                onClick={handleCloseDropdown}
              >
                Close
              </button>
            </div>
          ) : (
            <div className="relative mt-4">
              <div className="flex items-center  rounded-md ">
                <PhoneInput
                  country="in"
                  value={whatsAppNumber}
                  onChange={handlePhoneChange}
                  containerClass="custom-phone-input"
                  dropdownClass="z-50"
                  placeholder="Enter contact number"
                  excludeCountries={["id"]}
                />
              </div>
              <button
                className={`w-full py-2.5 mt-5 rounded-lg ${
                  whatsAppNumber.length < 12
                    ? "text-theme-buttonDisableText bg-theme-buttonDisable"
                    : " bg-theme-secondaryText text-theme-primaryBackground"
                } font-normal text-sm`}
                onClick={handleSave}
              >
                Verify
              </button>
              <button
                className={`w-full py-2.5 mt-3 rounded-lg font-normal text-sm text-theme-secondaryText border border-theme-secondaryText`}
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          )}
          {!successPage && (
            <p className="mt-6 text-theme-error text-sm font-normal">{error}</p>
          )}
        </div>
      )} */}

      {/* Chat Section */}
      <div className="flex flex-col flex-grow overflow-hidden">
        {isBrandTalk ? (
          <div className="bg-theme-primaryBackground w-full h-full overflow-y-auto">
            <PageChatData2
              topicId={topicId}
              isLoggedIn={isLoggedIn}
              myData={myData}
              user_id={topic.user}
              onNewMessageSent={(fn) => (newMessageScrollRef.current = fn)}
              channelName={channelName}
            />
          </div>
        ) : (
          <div className="bg-theme-secondaryBackground w-full h-full overflow-y-auto pt-1">
            {latestPinned && (
              <div
                onClick={() =>
                  scrollToChatRef.current &&
                  scrollToChatRef.current(latestPinned._id)
                }
                className="sticky top-0 z-20 flex items-center gap-2 border-b border-theme-chatDivider bg-theme-secondaryBackground px-3 py-2 cursor-pointer"
              >
                <span className="text-sm">📌</span>
                <p className="min-w-0 flex-1 truncate text-xs text-theme-secondaryText">
                  <span className="font-semibold">
                    {latestPinned.user?.username || latestPinned.user?.name}
                  </span>{" "}
                  {latestPinned.content
                    ? latestPinned.content
                    : latestPinned.media?.length
                    ? "Attachment"
                    : latestPinned.event
                    ? "Event"
                    : "Poll"}
                </p>
                {pinnedChats.length > 1 && (
                  <span className="shrink-0 text-[11px] text-theme-emptyEvent">
                    +{pinnedChats.length - 1} more
                  </span>
                )}
              </div>
            )}
            <PageChatData
              topicId={topicId}
              isLoggedIn={isLoggedIn}
              myData={myData}
              onNewMessageSent={(fn) => (newMessageScrollRef.current = fn)}
              registerScrollToChat={(fn) => (scrollToChatRef.current = fn)}
            />
          </div>
        )}

        {/* Media Preview Section */}
        {channelChat.media.length > 0 && (
          <div className="w-full bg-theme-chatDivider flex flex-row space-x-5 overflow-x-auto custom-scrollbar flex-shrink-0 z-50 pl-4 pr-2 pt-4 pb-2">
            {channelChat.media.map((item, index) => (
              <div
                key={item._id || index}
                className="bg-theme-tertiaryBackground rounded-lg p-2 relative"
              >
                <div className="flex flex-col">
                  <div
                    className="absolute -top-2 -right-1 cursor-pointer bg-theme-emptyEvent rounded-full p-1"
                    onClick={() => handleRemoveMedia(index, item._id)}
                  >
                    <img src={Delete} alt="delete" className="w-4 h-4" />
                  </div>
                  {item.type === "image" ? (
                    <img
                      src={item.url}
                      alt="media"
                      className="rounded-lg h-24 max-w-32 w-auto object-cover"
                      loading="lazy"
                    />
                  ) : item.type === "video" ? (
                    <video
                      controls
                      className="w-auto h-24 object-cover max-w-32 rounded-t-xl"
                    >
                      <source src={item.url} type="video/mp4" />
                    </video>
                  ) : (
                    <img
                      src={PdfImage}
                      alt="pdf"
                      className="rounded-lg h-24 max-w-32 w-auto"
                      loading="lazy"
                    />
                  )}
                  <p className="text-theme-secondaryText mt-1 font-normal text-xs truncate max-w-24">
                    {item.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}

        {channelChat.replyTo && channelChat?.replyUsername && (
          <div className="mt-1 flex w-full items-center gap-2.5 border-l-2 border-theme-secondaryText bg-theme-chatDivider/60 py-2 pl-3 pr-2">
            <div className="min-w-0 flex-1">
              <p className="text-[11px] font-semibold uppercase tracking-wide text-theme-placeholder">
                Replying to
              </p>
              <p className="truncate text-sm font-medium text-theme-secondaryText">
                {channelChat.replyUsername}
              </p>
            </div>
            <div
              className="flex h-7 w-7 flex-shrink-0 cursor-pointer items-center justify-center rounded-full hover:bg-theme-secondaryBackground"
              onClick={handleReplyClear}
            >
              <img src={Close} alt="close-icon" className="w-3 h-3" />
            </div>
          </div>
        )}

        {/* Input Section (preserved, just moved below reply/media) */}
        {(topic.editability === "anyone" ||
          topic.user === myData._id ||
          (topic.editability === "invite" &&
            topic.allowedEditUsers?.includes(myData._id))) && (
          <div className="flex flex-col items-center px-2 pt-2 pb-3 space-x-2 bg-theme-secondaryBackground border-t border-t-theme-chatDivider">
            <div className="relative flex flex-row items-center w-full">
              <img
                src={Smiley}
                alt="emoji"
                ref={emojiButtonRef}
                className="absolute right-2 cursor-pointer w-8 h-8"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowEmojiPicker((prev) => !prev);
                }}
              />
              <button
                type="button"
                aria-label="Voice typing"
                title="Voice typing"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleSpeechToText();
                }}
                className={`absolute right-11 flex h-8 w-8 items-center justify-center rounded-full ${
                  isListening
                    ? "bg-theme-error/15 text-theme-error animate-pulse"
                    : "text-theme-emptyEvent"
                }`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                  <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                  <line x1="12" y1="19" x2="12" y2="23" />
                  <line x1="8" y1="23" x2="16" y2="23" />
                </svg>
              </button>
              <div className="relative w-full">
                <div
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-0 pl-3 py-2 pr-20 font-inter font-light text-theme-secondaryText whitespace-pre-wrap break-words"
                  style={{ fontSize: "15px" }}
                >
                  {renderComposerHighlight(channelChat.content)}
                </div>
                <textarea
                  placeholder="Type your message"
                  className="relative pl-3 bg-transparent py-2 rounded-3xl pr-20 text-transparent placeholder:text-theme-emptyEvent placeholder:font-light focus:outline-none w-full font-inter font-light resize-none"
                  style={{
                    fontSize: "15px",
                    overflow: "hidden",
                    caretColor: "var(--theme-secondaryText)",
                  }}
                  value={channelChat.content}
                rows={1}
                ref={inputRef}
                onClick={() => setShowEmojiPicker(false)}
                onChange={(e) => {
                  const val = e.target.value;
                  setData(val);
                  dispatch(setChatField({ field: "content", value: val }));
                  autoExpand(e.target);
                  const ctx = getMentionContext(val, e.target.selectionStart);
                  setMentionQuery(ctx ? ctx.query : null);
                  setMentionIndex(0);
                }}
                onKeyDown={(e) => {
                  // When the mention picker is open, arrows/enter/tab drive it.
                  if (mentionQuery !== null && mentionMatches.length > 0) {
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      setMentionIndex((i) => (i + 1) % mentionMatches.length);
                      return;
                    }
                    if (e.key === "ArrowUp") {
                      e.preventDefault();
                      setMentionIndex(
                        (i) =>
                          (i - 1 + mentionMatches.length) % mentionMatches.length
                      );
                      return;
                    }
                    if (e.key === "Enter" || e.key === "Tab") {
                      e.preventDefault();
                      insertMention(mentionMatches[mentionIndex]);
                      return;
                    }
                    if (e.key === "Escape") {
                      e.preventDefault();
                      setMentionQuery(null);
                      return;
                    }
                  }
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    if (
                      channelChat.content.trim() !== "" ||
                      channelChat.media.length > 0
                    ) {
                      setShowEmojiPicker(false);
                      isBrandTalk ? handleSendBrandChat() : handleSendChat();
                    }
                  }
                }}
                />
              </div>
              {mentionQuery !== null &&
                (showBotEntry || mentionMatches.length > 0) && (
                <div className="absolute bottom-full left-0 z-50 mb-2 w-72 max-w-[85%] overflow-hidden rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground shadow-lg">
                  <ul className="max-h-56 overflow-y-auto py-1">
                    {showBotEntry && (
                      <li>
                        <button
                          type="button"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            openBot();
                          }}
                          className="flex w-full items-center gap-2.5 border-b border-theme-chatDivider px-3 py-2 text-left"
                        >
                          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-theme-accent text-theme-accentText">
                            <FiCpu size={15} />
                          </div>
                          <div className="min-w-0">
                            <p className="truncate text-sm font-medium text-theme-secondaryText">
                              @{bot.name}
                            </p>
                            <p className="truncate text-xs text-theme-emptyEvent">
                              Ask the assistant
                            </p>
                          </div>
                        </button>
                      </li>
                    )}
                    {mentionMatches.map((m, i) => {
                      const u = m.user || m;
                      return (
                        <li key={u._id}>
                          <button
                            type="button"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(m);
                            }}
                            onMouseEnter={() => setMentionIndex(i)}
                            className={`flex w-full items-center gap-2.5 px-3 py-2 text-left ${
                              i === mentionIndex
                                ? "bg-theme-tertiaryBackground"
                                : ""
                            }`}
                          >
                            {u.logo ? (
                              <img
                                src={u.logo}
                                alt=""
                                className="h-8 w-8 rounded-full object-cover"
                              />
                            ) : (
                              <div
                                className="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white"
                                style={{
                                  backgroundColor: u.color_logo || "#C4C4C4",
                                }}
                              >
                                {(u.name || u.username || "?")
                                  .charAt(0)
                                  .toUpperCase()}
                              </div>
                            )}
                            <div className="min-w-0">
                              <p className="truncate text-sm font-medium text-theme-secondaryText">
                                {u.name || u.username}
                              </p>
                              {u.username && (
                                <p className="truncate text-xs text-theme-emptyEvent">
                                  @{u.username}
                                </p>
                              )}
                            </div>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              {showEmojiPicker && (
                <div
                  className="absolute right-0 bottom-full mb-2 custom-emoji-wrapper"
                  ref={emojiRef}
                >
                  <EmojiPicker
                    onEmojiClick={onEmojiClick}
                    emojiStyle={EmojiStyle.NATIVE}
                    skinTonesDisabled={true}
                    theme={
                      document.documentElement.classList.contains("dark")
                        ? "dark"
                        : "light"
                    }
                    height={350}
                    searchDisabled={true}
                    lazyLoadEmojis={true}
                    previewConfig={previewConfig}
                  />
                </div>
              )}
            </div>

            <div className="flex flex-row justify-between items-center w-full px-2 mt-2">
              <div className="flex flex-row justify-start">
                {/* Hide the "+" entirely when every item inside its menu is
                    feature-gated off (mirror of the three item conditions). */}
                {(features.fileSharing !== false ||
                  (features.polls !== false &&
                    ((topic.user?._id || topic.user) === myData._id ||
                      features.memberPolls)) ||
                  (features.events !== false && topic.user === myData._id)) && (
                <>
                <div
                  ref={addMenuButtonRef}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowAddMenu((prev) => !prev);
                  }}
                  className="cursor-pointer"
                >
                  <img
                    src={AddButton}
                    alt="add-btn"
                    className="dark:block hidden w-8 h-8"
                  />
                  <img
                    src={AddButtonLight}
                    alt="add-btn"
                    className="dark:hidden w-8 h-8"
                  />
                </div>

                {showAddMenu && (
                  <div
                    className="absolute bottom-12 left-2 mb-2 bg-theme-tertiaryBackground border 
                    border-theme-modalBorder shadow-lg rounded-lg z-10 px-3 space-y-3 py-3"
                    onClick={(e) => e.stopPropagation()}
                    ref={addMenuRef}
                  >
                    {features.fileSharing !== false && (
                      <>
                        <div className="relative flex flex-row items-center space-x-2 cursor-pointer">
                          <img src={Media} alt="media" className-="w-5 h-5 mr-1" />
                          <p
                            className="block text-theme-emptyEvent"
                            role="menuitem"
                          >
                            Media
                          </p>
                          <input
                            type="file"
                            accept="image/*,video/*"
                            multiple
                            onChange={handleMediaChange}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                            ref={fileInputRef}
                          />
                        </div>
                        <div className="relative flex flex-row items-center space-x-2  cursor-pointer">
                          <img src={Document} alt="doc" className-="w-5 h-5 mr-1" />
                          <p
                            className="block text-theme-emptyEvent"
                            role="menuitem"
                          >
                            Document
                          </p>
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            multiple
                            onChange={handleFileChange}
                            className="absolute inset-0 opacity-0 cursor-pointer"
                            ref={fileInputRef}
                          />
                        </div>
                      </>
                    )}
                    {features.polls !== false &&
                      ((topic.user?._id || topic.user) === myData._id ||
                        features.memberPolls) && (
                      <div
                        className="flex flex-row items-center px-1 py-2 cursor-pointer"
                        onClick={handlePollOpen}
                      >
                        <img src={Poll} alt="poll" className="w-5 h-5 mr-2" />
                        <span className="text-theme-emptyEvent">Poll</span>
                      </div>
                    )}

                    {features.events !== false && topic.user === myData._id && (
                      <div
                        className="flex flex-row items-center px-1 py-2 cursor-pointer"
                        onClick={handleEventOpen}
                      >
                        <img
                          src={Event}
                          alt="event"
                          className="dark:block hidden w-5 h-5 mr-2"
                        />
                        <img
                          src={EventLight}
                          alt="event"
                          className="dark:hidden w-5 h-5 mr-2"
                        />
                        <span className="text-theme-emptyEvent">Event</span>
                      </div>
                    )}
                  </div>
                )}
                </>
                )}
                {features.talkToBrand !== false && topic.user !== myData._id && (
                  <div
                    className={`${
                      isBrandTalk
                        ? "bg-theme-accent text-theme-accentText"
                        : "bg-theme-tertiaryBackground text-theme-emptyEvent"
                    } relative ml-4 rounded-full px-3 py-1.5 flex flex-row items-center cursor-pointer`}
                    onClick={handleBrandTalk}
                  >
                    <FiMessageCircle className="w-4 h-4 mr-1" />
                    <p className="text-sm font-medium">Talk to us</p>
                    {brandUnread && !isBrandTalk && (
                      <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-theme-accent ring-2 ring-theme-secondaryBackground" />
                    )}
                  </div>
                )}
                <div
                  className={`xl:hidden flex text-center ml-4 rounded-full px-3 py-1.5 flex-row cursor-pointer ${
                    isOpen
                      ? "bg-theme-secondaryText text-theme-primaryBackground"
                      : "dark:bg-theme-tertiaryBackground bg-theme-buttonDisable text-theme-buttonDisableText"
                  }`}
                  onClick={toggleBottomSheet}
                >
                  <p
                    className={`text-sm font-light ${
                      isOpen
                        ? "text-theme-primaryBackground"
                        : "text-theme-emptyEvent"
                    }`}
                  >
                    Resource
                  </p>
                </div>
                {/* <div className="flex flex-row">
                  <img
                    src={isOpen ? Close : Menu}
                    alt="menu"
                    className={`cursor-pointer xl:hidden sm:flex hidden ${
                      isOpen ? "w-4 h-4" : "w-7 h-7"
                    } `}
                    onClick={toggleBottomSheet}
                  />
                  {isOpen ? (
                    <img
                      src={Close}
                      alt="menu"
                      className={`cursor-pointer flex sm:hidden ${
                        isOpen ? "w-4 h-4" : "w-7 h-7"
                      } `}
                      onClick={toggleBottomSheet}
                    />
                  ) : (
                    <div
                      className="sm:hidden flex space-x-1 cursor-pointer"
                      onClick={toggleBottomSheet}
                    >
                      <div className="w-1 h-1 bg-theme-primaryText rounded-full"></div>
                      <div className="w-1 h-1 bg-theme-primaryText rounded-full"></div>
                      <div className="w-1 h-1 bg-theme-primaryText rounded-full"></div>
                    </div>
                  )}
                </div> */}
              </div>

              {(data.length > 0 ||
                channelChat.content ||
                channelChat.media.length > 0) && (
                <div className="relative">
                  {loading ? (
                    <div className="absolute inset-0 flex items-center justify-center pl-2">
                      <div className="w-5 h-5 border-[3px] border-t-[3px] border-gray-900 mr-10 border-theme-secondaryText rounded-full animate-spin"></div>
                    </div>
                  ) : (
                    <img
                      src={SendButton}
                      alt="send-btn"
                      className="w-9 h-9 cursor-pointer"
                      onClick={
                        isBrandTalk ? handleSendBrandChat : handleSendChat
                      }
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageChat;
